import React, { memo, useMemo } from "react";
import CargandoIcon from "@icons-rf/timeline/loadingIcon2.svg?react";
import CompraDeTerreno from "@icons-rf/timeline/comprayVentaDeTerreno.svg?react";
import TraspasoDeTitulo from "@icons-rf/timeline/TraspasoDeTitulo.svg?react";
import AnteProyecto from "@icons-rf/timeline/depositoAnteProyecto.svg?react";
import NoObjecion from "@icons-rf/timeline/noObjecionIcon.svg?react";
import MAmbiente from "@icons-rf/timeline/ambiente.svg?react";
import Fideicomiso from "@icons-rf/timeline/fideicomisoIcon.svg?react";
import EnergiaProvisional from "@icons-rf/timeline/energiaProvisionalIcon.svg?react";
import TierraAlcantarillado from "@icons-rf/timeline/tierraAguaIcon.svg?react";
import Construccion from "@icons-rf/timeline/licenciaConstruccionIcon.svg?react";
import DefinitivoConfotur from "@icons-rf/timeline/confoturIcon.svg?react";
import Law from "@icons-rf/timeline/Law.svg?react";
import EnergiaDefinitivo from "@icons-rf/timeline/energiaDefinitivoIcon.svg?react";
import MaxCoreBallon from "@icons-rf/maxcore-ballow.svg?react";

const useTimeLineData = () => {
  const timeLineData = useMemo(() => {
    return [
      {
        id: 1,
        color: "#1A3668",
        month: "1",
        content: "Compra de terreno",
        icon: (
          <Icono icono={<CompraDeTerreno width={38} height={38} />} size="3.3rem" />
        )
      },
      {
        id: 2,
        color: "#B22B2E",
        month: "2",
        content: "Traspaso de título",
        icon: (
          <Icono icono={<TraspasoDeTitulo width={38} height={38} />} size="3.2rem" />
        )
      },
      {
        id: 3,
        color: "#404041",
        month: "3",
        content: "Tiempo de transición",
        icon: <Icono icono={<CargandoIcon width={38} height={38} />} size="2.5rem" />
      },
      {
        id: 4,
        color: "#1A3668",
        month: "4",
        content: "Depósito anteproyecto a ayuntamiento",
        icon: (
          <Icono
            icono={<AnteProyecto width={38} height={38} />}
            size="3.3rem"
            padding="0.7rem"
          />
        )
      },
      {
        id: 5,
        color: "#1A3668",
        month: "5",
        content: "Estatus jurídico | Previo MITUR",
        icon: <Icono icono={<Law width={38} height={38} />} size="2.8rem" />
      },
      {
        id: 6,
        color: "#1A3668",
        month: "6",
        content: "Inicio de Preventa",
        icon: (
          <Icono icono={<MaxCoreBallon width={48} height={48} />} size="3.2rem" />
        )
      },
      {
        id: 7,
        color: "#404041",
        month: "7",
        content: "Tiempo de transición",
        icon: <Icono icono={<CargandoIcon width={38} height={38} />} size="2.5rem" />
      },
      {
        id: 8,
        color: "#B22B2E",
        month: "8",
        content: "No objeción de ayuntamiento",
        icon: (
          <Icono
            icono={<NoObjecion width={38} height={38} />}
            size="2.9rem"
            padding="0.4rem"
          />
        )
      },
      {
        id: 9,
        color: "#B22B2E",
        month: "9",
        content: "Medio Ambiente",
        icon: <Icono icono={<MAmbiente width={38} height={38} />} size="4rem" />
      },
      {
        id: 10,
        color: "#B22B2E",
        month: "10",
        content: "Fideicomiso constituido",
        icon: <Icono icono={<Fideicomiso width={38} height={38} />} size="2.5rem" />
      },
      {
        id: 11,
        color: "#1A3668",
        month: "11",
        content: "Energia provisional",
        icon: (
          <Icono
            icono={<EnergiaProvisional width={38} height={38} />}
            size="2.5rem"
          />
        )
      },
      {
        id: 12,
        color: "#B22B2E",
        month: "12",
        content: "Movimiento de tierra",
        icon: (
          <Icono
            icono={<TierraAlcantarillado width={38} height={38} />}
            size="2.8rem"
          />
        )
      },
      {
        id: 13,
        color: "#404041",
        month: "13",
        content: "Tiempo de transición",
        icon: <Icono icono={<CargandoIcon width={38} height={38} />} size="2.5rem" />
      },
      {
        id: 14,
        color: "#B22B2E",
        month: "14",
        content: "Licencia de construcción",
        icon: <Icono icono={<Construccion width={38} height={38} />} size="3rem" />
      },
      {
        id: 15,
        color: "#007DC3",
        month: "15",
        content: "Definitivo CONFOTUR",
        icon: (
          <Icono
            icono={<DefinitivoConfotur width={38} height={38} />}
            size="4.5rem"
          />
        )
      },
      {
        id: 16,
        color: "#404041",
        month: "16",
        content: "Tiempo de transición",
        icon: <Icono icono={<CargandoIcon width={38} height={38} />} size="2.5rem" />
      },
      {
        id: 17,
        color: "#1A3668",
        month: "17",
        content: "Energia eléctrica definitiva",
        icon: (
          <Icono
            icono={<EnergiaDefinitivo width={38} height={38} />}
            size="2.5rem"
          />
        )
      }
    ];
  }, []);

  return { timeLineData };
};

export default useTimeLineData;

const Icono: React.FC<IconoProps> = memo(({ icono, size, padding }) => {
  return <div style={{ fontSize: size, paddingLeft: padding }}>{icono}</div>;
});

interface IconoProps {
  icono: React.ReactNode;
  size: string;
  padding?: string;
}
